export * from './Header/Header'
export * from './Footer/Footer'
export * from './Container/Container'
export * from './Content/Content'
export * from './DefaultPage/DefaultPage'
export * from './InnerPage/InnerPage'
export * from './Metatags/Metatags'
export * from '../../../providers/Tracking'
export * from './Article'
